import { render, staticRenderFns } from "./accidentReportCreate.vue?vue&type=template&id=2adc06d3&scoped=true&"
import script from "./accidentReportCreate.vue?vue&type=script&lang=js&"
export * from "./accidentReportCreate.vue?vue&type=script&lang=js&"
import style0 from "./accidentReportCreate.vue?vue&type=style&index=0&id=2adc06d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adc06d3",
  null
  
)

export default component.exports